// @flow

import {Cookie} from './Cookie';
import COOKIES from '../../../cookies.yaml';

const cookies = Object.keys(COOKIES).map(
  (name) => new Cookie(name, COOKIES[name]),
);

const inexactCookies = cookies.filter((c) => c.inexact);

/**
 * Contains information about all known cookies, loaded from pay-server/cookies/cookies.yaml.
 * Only cookies which have entries in the manifest are allowed to be set.
 * @private
 */
export const CookieManifest = {
  /**
   * Gets the Cookie definintion for the specified cookie from the manifest.
   * If matching cookie exists, throws an error.
   * @param {string} name The name of the cookie to retrieve.
   */
  get(name: string): Cookie {
    // First, try to match the cookie name exactly.
    if (COOKIES[name]) {
      return new Cookie(name, COOKIES[name]);
    }

    // If we didn't find an exact match, try to match by pattern instead.
    for (const cookie of inexactCookies) {
      if (cookie.isMatch(name)) return cookie;
    }

    // If we couldn't find a match, throw an error.
    throw new Error(
      `No cookie matching the name ${name} was found in the manifest. ` +
        `If you're adding a new cookie, please visit go/cookies for more information!`,
    );
  },
};
